
import { Inject, Service, Container } from 'typedi';
import Scroll from './scoll';

@Service()
export class Utils {

    @Inject()
    scroll: Scroll;

}

export default Container.get(Utils);